var map = {
	"./translation-default.czech.json": "./src/app/website-builder/translation-default.czech.json",
	"./translation-default.danish.json": "./src/app/website-builder/translation-default.danish.json",
	"./translation-default.dutch.json": "./src/app/website-builder/translation-default.dutch.json",
	"./translation-default.estonian.json": "./src/app/website-builder/translation-default.estonian.json",
	"./translation-default.finnish.json": "./src/app/website-builder/translation-default.finnish.json",
	"./translation-default.french.json": "./src/app/website-builder/translation-default.french.json",
	"./translation-default.german.json": "./src/app/website-builder/translation-default.german.json",
	"./translation-default.greek.json": "./src/app/website-builder/translation-default.greek.json",
	"./translation-default.hungarian.json": "./src/app/website-builder/translation-default.hungarian.json",
	"./translation-default.italian.json": "./src/app/website-builder/translation-default.italian.json",
	"./translation-default.latvian.json": "./src/app/website-builder/translation-default.latvian.json",
	"./translation-default.lithuanian.json": "./src/app/website-builder/translation-default.lithuanian.json",
	"./translation-default.norwegian.json": "./src/app/website-builder/translation-default.norwegian.json",
	"./translation-default.polish.json": "./src/app/website-builder/translation-default.polish.json",
	"./translation-default.portuguese.json": "./src/app/website-builder/translation-default.portuguese.json",
	"./translation-default.slovak.json": "./src/app/website-builder/translation-default.slovak.json",
	"./translation-default.slovenian.json": "./src/app/website-builder/translation-default.slovenian.json",
	"./translation-default.spanish.json": "./src/app/website-builder/translation-default.spanish.json",
	"./translation-default.swedish.json": "./src/app/website-builder/translation-default.swedish.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/website-builder recursive ^\\.\\/translation\\-default\\..*\\.json$";


//////////////////
// WEBPACK FOOTER
// ./src/app/website-builder ^\.\/translation\-default\..*\.json$
// module id = ./src/app/website-builder recursive ^\.\/translation\-default\..*\.json$
// module chunks = main